import { ConnectMomentChatCard } from "@/components/conversations/activities/connect-moment/connect-moment-chat-card";
import type {
  ConnectActivityConfig,
  ConnectActivityResult,
} from "@/lib/api/activities";
import type { ActivityResultCardProps } from "@/lib/activities/registry";

export function ConnectMomentResultCard({
  participants,
  result,
  onClick,
}: ActivityResultCardProps<ConnectActivityConfig, ConnectActivityResult>) {
  return (
    <ConnectMomentChatCard
      activityStatus="completed"
      isExpired={false}
      result={result}
      teenName={participants.teen.name ?? "Teen"}
      ownerAvatarUrl={participants.mentor.avatarUrl}
      teenAvatarUrl={participants.teen.avatarUrl}
      onOpen={onClick}
    />
  );
}
